const promoCodeTypes = Object.freeze({
  TRACKING: 'TRACKING',
  AMOUNT: 'AMOUNT',
  PERCENTAGE: 'PERCENTAGE'
})

export default promoCodeTypes
